import { BusinessEntity } from '@commenda/prisma';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

export type TTask = {
  corporation: BusinessEntity;
  isEditFiscalYearDetailsAllowed: boolean;
};

export type TTasksResponse = TTask[];

export default function useCAFirmTasks(caFirmId: string) {
  const {
    data,
    error,
    mutate,
  }: {
    data: TTasksResponse;
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    caFirmId ? `caFirm/getActiveTasks/${caFirmId}` : null,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
  };
}
